// @flow
import React, { Fragment } from 'react';
import moment from 'moment';
import { MdEdit } from 'react-icons/lib/md';
import Clock from './clock';

import textStyles from '../Text/textCell.css';

export type TimeCellPropTypes = {
  value: string,
  original: Object,
  onChange?: Function,
};

type TimeStateTypes = {
  isEditing: boolean,
  editingValue: Object,
};

class TimeCell extends React.Component<TimeCellPropTypes, TimeStateTypes> {
  constructor(props: TimeCellPropTypes) {
    super(props);

    this.state = {
      isEditing: false,
      editingValue: moment(props.value, ['hh:mm a', 'H:m']).format('h:mm A').toString(),
    };
  }

  show = () => {
    this.setState({ isEditing: true });
  };

  hide = () => {
    this.setState({ isEditing: false });
  };

  handleChange = (value: Object) => {
    this.setState({ editingValue: value.formatted24 });
  };

  _onDone = () => {
    const { onChange, original } = this.props;
    const { editingValue } = this.state;
    if (onChange) {
      onChange(original, moment(editingValue, ['h:m a', 'HH:mm']).utc().format('HH:mm').toString());
    }
    this.setState({ isEditing: false });
  }

  render() {
    const { isEditing, editingValue } = this.state;
    const { value } = this.props;
    return (
      <div className={textStyles.text}>
        {
          isEditing ? (
            <Clock
              time={moment(editingValue, ['h:m a', 'HH:mm']).format('HH:mm').toString()}
              onChange={this.handleChange.bind(this)}
              onDoneClick={this._onDone.bind(this)}
              onClickOutsideHandler={this.hide.bind(this)}
            />
          ) : (
            <Fragment>
              <span
                className={textStyles.value}
                onClick={this.show.bind(this)}
                role="presentation"
              >
                { moment(value, ['hh:mm a', 'H:m']).format('h:mm A').toString() }
              </span>
              <MdEdit size={20} onClick={this.show.bind(this)} />
            </Fragment>
          )
        }
      </div>
    );
  }
}

export default TimeCell;



// WEBPACK FOOTER //
// ./src/scripts/components/DataTable/Cells/Time/index.jsx